import Accordion from "./Classes/Accordion.js";
import Animation from "./Classes/Animation.js";
import Cv from "./Classes/Cv";
import Video from "./Classes/Video";
import TableIconReplacer from "./Classes/TableIconReplacer.js";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Gri from "./Classes/Gri.js";
import CountUpNumbers from "./Classes/CountUpNumbers.js";
import ScrollNav from "./Classes/ScrollNav.js";
import Anchor from "./Classes/Anchor.js";
import Wavesurfer from "./Classes/Wavesurfer.js";
import Lottie from "./Classes/Lottie.js";
import CookieBotHandler from "./Classes/CookiebotHandler.js";


window.addEventListener("page_event_load", () => {
  new Video();
  new Cv();
  new Animation();

  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new Anchor();
  new TableIconReplacer();
  new Wavesurfer();
  new Lottie();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new Gri();

  new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number',
    classIn: 'in-viewport',
    classOut: 'not-in-viewport',
    langArray: ['de','en'],
    decimalArray: [',', '.'],
    thousandSepArray: [' ',' '],
  });

  new ScrollNav();

  // let searchParams = new URLSearchParams(window.location.search);
	// if(window.location.href.includes('impressum') || window.location.href.includes('datenschutzerklaerung') || window.location.href.includes('imprint') || window.location.href.includes('data-protection-statement')) {
	// 	if(!searchParams.get('t')) {
	// 		window.location.href = window.location.href + '?t=1';
	// 	}
	// }

  new CookieBotHandler();
});


window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });
});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
